export {
    UserRole,
    EntityType,
    ActionType,
    InvitationStatus,
    AuditAction,
    AuditActorType,
    PatientInvitationStatus,
    PregnancyType,
    PregnancyStatus,
    PregnancyClosureReason,
    TimelineEventType,
    EddMethod,
    ActiveEdd,
    DocumentType,
    PregnancyPhase,
    ScreeningType,
    RiskFactorStatus,
    MedicationStatus,
    TaskType,
    TaskStatus
} from '@prismaclient/enums'

export const INVITATION_EXPIRY_DAYS = 7

/** Client-side cooldown between magic link resend attempts on the login screen. */
export const MAGIC_LINK_RESEND_COOLDOWN_SECONDS = 30
